/* unplugin-vue-components disabled */import __unplugin_components_1 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "head-container"
};
const _hoisted_3 = {
  class: "head-container"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将文件拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1);
const _hoisted_6 = {
  class: "el-upload__tip text-center"
};
const _hoisted_7 = {
  class: "el-upload__tip"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "仅允许导入xls、xlsx格式文件。", -1);
const _hoisted_9 = {
  class: "dialog-footer"
};
import { getToken } from "@/utils/auth";
import { treeselect } from "@/api/system/dept";
import { addUser, changeUserStatus, delUser, getUser, listUser, resetUserPwd, updateUser } from "@/api/system/user";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const {
      sys_normal_disable,
      sys_user_sex
    } = proxy.useDict("sys_normal_disable", "sys_user_sex");
    const userList = ref([]);
    const open = ref(false);
    const loading = ref(true);
    const showSearch = ref(true);
    const ids = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const total = ref(0);
    const title = ref("");
    const dateRange = ref([]);
    const deptName = ref("");
    const deptOptions = ref(undefined);
    const initPassword = ref(undefined);
    const postOptions = ref([]);
    const roleOptions = ref([]);
    /*** 用户导入参数 */
    const upload = reactive({
      // 是否显示弹出层（用户导入）
      open: false,
      // 弹出层标题（用户导入）
      title: "",
      // 是否禁用上传
      isUploading: false,
      // 是否更新已经存在的用户数据
      updateSupport: 0,
      // 设置上传的请求头部
      headers: {
        Authorization: "Bearer " + getToken()
      },
      // 上传的地址
      url: process.env.VUE_APP_BASE_API + "/system/user/importData"
    });
    // 列显隐信息
    const columns = ref([{
      key: 0,
      label: `用户编号`,
      visible: true
    }, {
      key: 1,
      label: `用户名称`,
      visible: true
    }, {
      key: 2,
      label: `用户昵称`,
      visible: true
    }, {
      key: 3,
      label: `部门`,
      visible: true
    }, {
      key: 4,
      label: `手机号码`,
      visible: true
    }, {
      key: 5,
      label: `状态`,
      visible: true
    }, {
      key: 6,
      label: `创建时间`,
      visible: true
    }]);
    const data = reactive({
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined
      },
      rules: {
        userName: [{
          required: true,
          message: "用户名称不能为空",
          trigger: "blur"
        }, {
          min: 2,
          max: 20,
          message: "用户名称长度必须介于 2 和 20 之间",
          trigger: "blur"
        }],
        nickName: [{
          required: true,
          message: "用户昵称不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "用户密码不能为空",
          trigger: "blur"
        }, {
          min: 5,
          max: 20,
          message: "用户密码长度必须介于 5 和 20 之间",
          trigger: "blur"
        }],
        email: [{
          type: "email",
          message: "请输入正确的邮箱地址",
          trigger: ["blur", "change"]
        }],
        phonenumber: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }]
      }
    });
    const {
      queryParams,
      form,
      rules
    } = toRefs(data);

    /** 通过条件过滤节点  */
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    /** 根据名称筛选部门树 */
    watch(deptName, val => {
      proxy.$refs["deptTreeRef"].filter(val);
    });

    /** 查询部门下拉树结构 */
    function getTreeselect() {
      treeselect().then(response => {
        deptOptions.value = response.data;
      });
    }
    ;

    /** 查询用户列表 */
    function getList() {
      loading.value = true;
      listUser(proxy.addDateRange(queryParams.value, dateRange.value)).then(res => {
        loading.value = false;
        userList.value = res.rows;
        total.value = res.total;
      });
    }
    ;

    /** 节点单击事件 */
    function handleNodeClick(data) {
      queryParams.value.deptId = data.id;
      handleQuery();
    }
    ;

    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    ;

    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      proxy.resetForm("queryRef");
      handleQuery();
    }
    ;

    /** 删除按钮操作 */
    function handleDelete(row) {
      const userIds = row.userId || ids.value;
      proxy.$modal.confirm("是否确认删除用户编号为\"" + userIds + "\"的数据项？").then(function () {
        return delUser(userIds);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
    ;

    /** 导出按钮操作 */
    function handleExport() {
      proxy.download("system/user/export", {
        ...queryParams.value
      }, `user_${new Date().getTime()}.xlsx`);
    }
    ;

    /** 用户状态修改  */
    function handleStatusChange(row) {
      let text = row.status === "0" ? "启用" : "停用";
      proxy.$modal.confirm("确认要\"" + text + "\"\"" + row.userName + "\"用户吗?").then(function () {
        return changeUserStatus(row.userId, row.status);
      }).then(() => {
        proxy.$modal.msgSuccess(text + "成功");
      }).catch(function () {
        row.status = row.status === "0" ? "1" : "0";
      });
    }
    ;

    /** 更多操作 */
    function handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          handleResetPwd(row);
          break;
        case "handleAuthRole":
          handleAuthRole(row);
          break;
        default:
          break;
      }
    }
    ;

    /** 跳转角色分配 */
    function handleAuthRole(row) {
      const userId = row.userId;
      router.push("/system/user-auth/role/" + userId);
    }
    ;

    /** 重置密码按钮操作 */
    function handleResetPwd(row) {
      proxy.$prompt("请输入\"" + row.userName + "\"的新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputPattern: /^.{5,20}$/,
        inputErrorMessage: "用户密码长度必须介于 5 和 20 之间"
      }).then(({
        value
      }) => {
        resetUserPwd(row.userId, value).then(response => {
          proxy.$modal.msgSuccess("修改成功，新密码是：" + value);
        });
      }).catch(() => {});
    }
    ;

    /** 选择条数  */
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.userId);
      single.value = selection.length != 1;
      multiple.value = !selection.length;
    }
    ;

    /** 导入按钮操作 */
    function handleImport() {
      upload.title = "用户导入";
      upload.open = true;
    }
    ;

    /** 下载模板操作 */
    function importTemplate() {
      proxy.download("system/user/importTemplate", {}, `user_template_${new Date().getTime()}.xlsx`);
    }
    ;
    /**文件上传中处理 */
    const handleFileUploadProgress = (event, file, fileList) => {
      upload.isUploading = true;
    };
    /** 文件上传成功处理 */
    const handleFileSuccess = (response, file, fileList) => {
      upload.open = false;
      upload.isUploading = false;
      proxy.$refs["uploadRef"].handleRemove(file);
      proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", {
        dangerouslyUseHTMLString: true
      });
      getList();
    };

    /** 提交上传文件 */
    function submitFileForm() {
      proxy.$refs["uploadRef"].submit();
    }
    ;

    /** 初始化部门数据 */
    function initTreeData() {
      // 判断部门的数据是否存在，存在不获取，不存在则获取
      if (deptOptions.value === undefined) {
        treeselect().then(response => {
          deptOptions.value = response.data;
        });
      }
    }
    ;

    /** 重置操作表单 */
    function reset() {
      form.value = {
        userId: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phonenumber: undefined,
        email: undefined,
        sex: undefined,
        status: "0",
        remark: undefined,
        postIds: [],
        roleIds: []
      };
      proxy.resetForm("userRef");
    }
    ;

    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    ;

    /** 新增按钮操作 */
    function handleAdd() {
      reset();
      initTreeData();
      getUser().then(response => {
        postOptions.value = response.posts;
        roleOptions.value = response.roles;
        open.value = true;
        title.value = "添加用户";
        form.value.password = initPassword.value;
      });
    }
    ;

    /** 修改按钮操作 */
    function handleUpdate(row) {
      reset();
      initTreeData();
      const userId = row.userId || ids.value;
      getUser(userId).then(response => {
        form.value = response.data;
        postOptions.value = response.posts;
        roleOptions.value = response.roles;
        form.value.postIds = response.postIds;
        form.value.roleIds = response.roleIds;
        open.value = true;
        title.value = "修改用户";
        form.password = "";
      });
    }
    ;

    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["userRef"].validate(valid => {
        if (valid) {
          if (form.value.userId != undefined) {
            updateUser(form.value).then(response => {
              proxy.$modal.msgSuccess("修改成功");
              open.value = false;
              getList();
            });
          } else {
            addUser(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              open.value = false;
              getList();
            });
          }
        }
      });
    }
    ;
    getTreeselect();
    getList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_upload_filled = _resolveComponent("upload-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_upload = _resolveComponent("el-upload");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
            modelValue: _unref(deptName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deptName) ? deptName.value = $event : null),
            clearable: "",
            placeholder: "请输入部门名称",
            "prefix-icon": "Search",
            style: {
              "margin-bottom": "20px"
            }
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tree, {
            ref: "deptTreeRef",
            data: _unref(deptOptions),
            "expand-on-click-node": false,
            "filter-node-method": filterNode,
            props: {
              label: 'label',
              children: 'children'
            },
            "default-expand-all": "",
            "highlight-current": "",
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
            ref: "queryRef",
            inline: true,
            model: _unref(queryParams),
            "label-width": "68px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用户名称",
              prop: "userName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).userName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).userName = $event),
                clearable: "",
                placeholder: "请输入用户名称",
                style: {
                  "width": "240px"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "phonenumber"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).phonenumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(queryParams).phonenumber = $event),
                clearable: "",
                placeholder: "请输入手机号码",
                style: {
                  "width": "240px"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(queryParams).status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(queryParams).status = $event),
                clearable: "",
                placeholder: "用户状态",
                style: {
                  "width": "240px"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.value,
                    label: dict.label,
                    value: dict.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "创建时间",
              style: {
                "width": "308px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(dateRange),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(dateRange) ? dateRange.value = $event : null),
                "end-placeholder": "结束日期",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                type: "daterange",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Search",
                type: "primary",
                onClick: handleQuery
              }, {
                default: _withCtx(() => [_createTextVNode("搜索")]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Refresh",
                onClick: resetQuery
              }, {
                default: _withCtx(() => [_createTextVNode("重置")]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
            gutter: 10,
            class: "mb8"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Plus",
                plain: "",
                type: "primary",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [_createTextVNode("新增 ")]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:add']]])]),
              _: 1
            }, 8, ["span"]), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(single),
                icon: "Edit",
                plain: "",
                type: "success",
                onClick: handleUpdate
              }, {
                default: _withCtx(() => [_createTextVNode("修改 ")]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['system:user:edit']]])]),
              _: 1
            }, 8, ["span"]), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(multiple),
                icon: "Delete",
                plain: "",
                type: "danger",
                onClick: handleDelete
              }, {
                default: _withCtx(() => [_createTextVNode("删除 ")]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['system:user:remove']]])]),
              _: 1
            }, 8, ["span"]), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Upload",
                plain: "",
                type: "info",
                onClick: handleImport
              }, {
                default: _withCtx(() => [_createTextVNode("导入 ")]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:import']]])]),
              _: 1
            }, 8, ["span"]), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Download",
                plain: "",
                type: "warning",
                onClick: handleExport
              }, {
                default: _withCtx(() => [_createTextVNode("导出 ")]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:export']]])]),
              _: 1
            }, 8, ["span"]), _createVNode(_component_right_toolbar, {
              showSearch: _unref(showSearch),
              "onUpdate:showSearch": _cache[5] || (_cache[5] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
              columns: _unref(columns),
              onQueryTable: getList
            }, null, 8, ["showSearch", "columns"])]),
            _: 1
          }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(userList),
            onSelectionChange: handleSelectionChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              align: "center",
              type: "selection",
              width: "50"
            }), _unref(columns)[0].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "userId",
              align: "center",
              label: "用户编号",
              prop: "userId"
            })) : _createCommentVNode("", true), _unref(columns)[1].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "userName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "用户名称",
              prop: "userName"
            })) : _createCommentVNode("", true), _unref(columns)[2].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "nickName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "用户昵称",
              prop: "nickName"
            })) : _createCommentVNode("", true), _unref(columns)[3].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "deptName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "部门",
              prop: "dept.deptName"
            })) : _createCommentVNode("", true), _unref(columns)[4].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "phonenumber",
              align: "center",
              label: "手机号码",
              prop: "phonenumber",
              width: "120"
            })) : _createCommentVNode("", true), _unref(columns)[5].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "status",
              align: "center",
              label: "状态"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_switch, {
                modelValue: scope.row.status,
                "onUpdate:modelValue": $event => scope.row.status = $event,
                "active-value": "0",
                "inactive-value": "1",
                onChange: $event => handleStatusChange(scope.row)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 1
            })) : _createCommentVNode("", true), _unref(columns)[6].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              align: "center",
              label: "创建时间",
              prop: "createTime",
              width: "160"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.createTime)), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              align: "center",
              "class-name": "small-padding fixed-width",
              label: "操作",
              width: "150"
            }, {
              default: _withCtx(scope => [scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "修改",
                placement: "top"
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Edit",
                  type: "primary",
                  link: "",
                  onClick: $event => handleUpdate(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:edit']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "删除",
                placement: "top"
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Delete",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDelete(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:remove']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2,
                content: "重置密码",
                placement: "top"
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Key",
                  type: "primary",
                  link: "",
                  onClick: $event => handleResetPwd(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:resetPwd']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 3,
                content: "分配角色",
                placement: "top"
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "CircleCheck",
                  type: "primary",
                  link: "",
                  onClick: $event => handleAuthRole(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:edit']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
            limit: _unref(queryParams).pageSize,
            "onUpdate:limit": _cache[6] || (_cache[6] = $event => _unref(queryParams).pageSize = $event),
            page: _unref(queryParams).pageNum,
            "onUpdate:page": _cache[7] || (_cache[7] = $event => _unref(queryParams).pageNum = $event),
            total: _unref(total),
            onPagination: getList
          }, null, 8, ["limit", "page", "total"]), [[_vShow, _unref(total) > 0]])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _isRef(open) ? open.value = $event : null),
        title: _unref(title),
        "append-to-body": "",
        width: "600px"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "userRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "用户昵称",
                prop: "nickName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).nickName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).nickName = $event),
                  maxlength: "30",
                  placeholder: "请输入用户昵称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).deptId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).deptId = $event),
                  data: _unref(deptOptions),
                  props: {
                    value: 'id',
                    label: 'label',
                    children: 'children'
                  },
                  "check-strictly": "",
                  placeholder: "请选择归属部门",
                  "value-key": "id"
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "手机号码",
                prop: "phonenumber"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).phonenumber,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).phonenumber = $event),
                  maxlength: "11",
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).email = $event),
                  maxlength: "50",
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_unref(form).userId == undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "用户名称",
                prop: "userName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).userName,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).userName = $event),
                  maxlength: "30",
                  placeholder: "请输入用户名称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_unref(form).userId == undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "用户密码",
                prop: "password"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).password = $event),
                  maxlength: "20",
                  placeholder: "请输入用户密码",
                  "show-password": "",
                  type: "password"
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "用户性别"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).sex,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).sex = $event),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_user_sex), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.value,
                      label: dict.label,
                      value: dict.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).status = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "岗位"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).postIds,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).postIds = $event),
                  multiple: "",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postOptions), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.postId,
                      disabled: item.status == 1,
                      label: item.postName,
                      value: item.postId
                    }, null, 8, ["disabled", "label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).roleIds,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).roleIds = $event),
                  multiple: "",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roleOptions), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.roleId,
                      disabled: item.status == 1,
                      label: item.roleName,
                      value: item.roleId
                    }, null, 8, ["disabled", "label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).remark = $event),
                  placeholder: "请输入内容",
                  type: "textarea"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(upload).open,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(upload).open = $event),
        title: _unref(upload).title,
        "append-to-body": "",
        width: "400px"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitFileForm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = $event => _unref(upload).open = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          action: _unref(upload).url + '?updateSupport=' + _unref(upload).updateSupport,
          "auto-upload": false,
          disabled: _unref(upload).isUploading,
          headers: _unref(upload).headers,
          limit: 1,
          "on-progress": handleFileUploadProgress,
          "on-success": handleFileSuccess,
          accept: ".xlsx, .xls",
          drag: ""
        }, {
          tip: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(upload).updateSupport,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(upload).updateSupport = $event)
          }, null, 8, ["modelValue"]), _createTextVNode(" 是否更新已经存在的用户数据 ")]), _hoisted_8, _createVNode(_component_el_link, {
            underline: false,
            style: {
              "font-size": "12px",
              "vertical-align": "baseline"
            },
            type: "primary",
            onClick: importTemplate
          }, {
            default: _withCtx(() => [_createTextVNode("下载模板 ")]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_upload_filled)]),
            _: 1
          }), _hoisted_5]),
          _: 1
        }, 8, ["action", "disabled", "headers"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};